import ReactGA from "react-ga4";

export const initializeGoogleAnalytics = () => {
  const gaApiKey = import.meta.env.VITE_GA_API_KEY;

  if (gaApiKey) {
    // https://github.com/codler/react-ga4/issues/91
    (ReactGA as unknown as { default: typeof ReactGA }).default.initialize(
      gaApiKey,
      {
        gaOptions: { siteSpeedSampleRate: 100 },
      }
    );
  }
};
